import { Actions } from '../../../types/tour';

export function goPrev() {
  return { type: Actions.GoPrev };
}

export function goNext() {
  return { type: Actions.GoNext };
}

export function goTo(to: number) {
  return { type: Actions.GoTo, to };
}

export function showModal(title: string, content: string) {
  return {
    type: Actions.ShowModal,
    modal: { title, content },
  };
}

export function hideModal() {
  return { type: Actions.HideModal };
}

export function setComplete(stepIndex: number, parentStepIndex: number) {
  return {
    type: Actions.SetComplete,
    step: stepIndex,
    parentStep: parentStepIndex,
  };
}
